<template>
    <div class="box">
  
      
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6">
                    <a-form-item label="工艺名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入工艺名称" v-model="queryParam.craftName"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6">
                        <a-form-item label="工序名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入工序名称" v-model="queryParam.proceName"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6">
                        <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input placeholder="请输入商品名称" v-model="queryParam.productName"></a-input>
                        </a-form-item>
                    </a-col>
                    </a-row>
                  <a-row :gutter="24">
                    <a-col :md="6">
                        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                            <a-select v-model="queryParam.status" placeholder="请选择状态">
                            <a-select-option value="">全部</a-select-option>
                            <a-select-option value="1">处理中</a-select-option>
                            <a-select-option value="2">上传成功</a-select-option>
                            <a-select-option value="3">上传失败</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                  <a-col :md="6">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-col :md="6" :sm="24">
                        <a-button type="primary" @click="searchQuery">查询</a-button>
                        <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                      </a-col>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
            </div>
  
            <!-- table区域-begin -->
            <div>
                <a-table
                    ref="table"
                    size="middle"
                    bordered
                    rowKey="uuid"
                    :columns="columns"
                    :dataSource="dataSource"
                    :pagination="ipagination"
                    @change="handleTableChange"
                >
                <template slot="status" slot-scope="status">
                    <a-tag color="blue" v-if="status === 1">处理中</a-tag>
                    <a-tag color="green" v-else-if="status === 2">上传成功</a-tag>
                    <a-tag color="red" v-else-if="status === 3">上传失败</a-tag>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a @click="handleEdit(record)">查看</a>
                    <a-divider type="vertical" />
                    <a @click="uploadOrder(record)">上传</a>
                </template>
                </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <eventLog ref="eventLog" @ok="handleOk" @cancel="handleCancel"></eventLog>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { getTraceEventList, traceSaveForEventId } from '@/api/api'
    import AllSelectModel from '../H5Create/modules/allSelectModel.vue'
    import EventLog from './modules/eventLog.vue'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
            AllSelectModel,
            EventLog
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
  
          // 查询条件
          queryParam: {},
          menuItems: [],
          dropdownStates: {},
          dropdownVisible: false, // 控制下拉框的显示状态
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
                title: '状态', 
                dataIndex: 'status', 
                align:"center", 
                scopedSlots: { customRender: 'status' },render: (text) => text || "--",
                sorter: (a, b) => a.status - b.status
            },
            {
                title: '工艺名称 ', 
                dataIndex: 'craftName', 
                align:"center",
                sorter: (a, b) => a.craftName.localeCompare(b.craftName),
            },
            {
                title: '工序名称 ', 
                dataIndex: 'proceName', 
                align:"center",
                sorter: (a, b) => a.proceName.localeCompare(b.proceName),
            },
            {
                title: '商品名称 ', 
                dataIndex: 'productName', 
                align:"center",
                sorter: (a, b) => a.productName.localeCompare(b.productName),
            },
            {
                title: '规格', 
                dataIndex: 'standard',
                align:"center",
                sorter: (a, b) => a.standard.localeCompare(b.standard),
            },
            {
                title: '型号 ', 
                dataIndex: 'model', 
                align:"center",
                sorter: (a, b) => a.model.localeCompare(b.model),
            },
            {
                title: '来源 ', 
                dataIndex: 'updateBy', 
                align:"center",
                sorter: (a, b) => a.updateBy.localeCompare(b.updateBy),
            },
            {
                title: '时间 ',
                dataIndex: 'updateTime',
                align:"center",
                sorter: (a, b) => new Date(a.updateTime) - new Date(b.updateTime),
            },
            {
                title: '操作',
                dataIndex: 'action',
                align:"center",
                scopedSlots: { customRender: 'action' },
                width: '150px'
            }
            
          ],
          // 控制列的显示状态
          columnVisibility: {
            codeRuleId: false, // 设置为 false 隐藏该列
            formTemplateId: false, // 设置为 false 隐藏该列
            proceCode: false
          },
        ipagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            showTotal: (total) => `共 ${total} 条`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30'],
            onShowSizeChange: (current, pageSize) => this.onShowSizeChange(current, pageSize),
        },
        }
      },
      mounted() {
        this.getTraceEventLists();
      },
      methods: {
        
        // 获取工艺列表
        async getTraceEventLists(){
          this.menuItems = []
          const params = {
            craftName: this.queryParam.craftName,
            proceName: this.queryParam.proceName,
            productName: this.queryParam.productName,
            status: this.queryParam.status,
            pageSize: this.ipagination.pageSize,
            currentPage: this.ipagination.current
          }
          const res = await getTraceEventList(params)
          if(  res.code == 200 && res.success == true ){
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          } else {
            this.$message.warning(res.message)
          }
        },
        getColor(status) {
            if ( status == 1 ) return '处理中'
            else if ( status == 2 ) return '上传成功'
            else if ( status == 3 ) return '上传失败'
            else return '未知状态'
        },
        handleTableChange(pagination, filters, sorter) {
            this.ipagination = pagination;
            this.getTraceEventLists();
        },
        searchQuery() {
            console.log('查询条件:', this.queryParam);
            this.getTraceEventLists();
        },
        searchReset() {
            this.queryParam = {};
            this.getTraceEventLists();
        },
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current;
            this.ipagination.pageSize = pageSize;
            // 重新获取数据或处理分页逻辑
        },
        handleEdit(record){
          this.$refs.eventLog.show(record)
        },
        // 上传
        async uploadOrder(record){
          const params = {
            recordId: record.id
          }
          const res = await traceSaveForEventId(params)
          if(  res.code == 200 && res.success == true ){
            this.$message.success(res.message)
            this.getTraceEventLists()
          } else {
            this.$message.warning(res.message)
          }
        }

      },
    }
  </script>
  
  <style scoped>
  
  </style>